import { Column, FieldType, FieldValue, option } from "../../../../features/ui"
import { CreditAccountPaymentTypeId, Data2, DataTypeSelectorTable } from "../../../../features/data-types"
import { PaymentType, PaymentTypeName, usePaymentTypeLoaders } from "../../../administration"
import { useMemo } from "react"

type Props = {
    rows: PaymentType[]
    readOnly?: boolean
    onChange: (data: PaymentType[]) => void
}

export const PaymentTypesTable = (props: Props) => {
    const { rows, readOnly, onChange } = props

    const paymentTypeLoaders = usePaymentTypeLoaders()
    const paymentTypes = useMemo(() => paymentTypeLoaders().findAllPaymentTypes().filter(paymentType => paymentType.id !== CreditAccountPaymentTypeId), [])
    const paymentTypeOptions = useMemo(() => paymentTypes
        .filter(paymentType => !paymentType.archived)
        .map(paymentType => option(paymentType.id, paymentType.name))
    , [paymentTypes, rows])

    const columns: Column[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Medio de Pago',
            render: (value?: FieldValue) => {
                const paymentType = paymentTypes.find(paymentType => paymentType.name === value)!
                return <PaymentTypeName paymentType={paymentType} />
            }
        }
    ]

    const rowData = async (id: string) => {
        const { findPaymentType } = paymentTypeLoaders()
        return findPaymentType(id)!
    }

    const handleChange = (data: Data2[]) => onChange(data as PaymentType[])

    return (
        <DataTypeSelectorTable
            rows={rows}
            columns={columns}
            options={paymentTypeOptions}
            placeholder="Seleccionar medio de pago"
            rowData={rowData}
            readOnly={readOnly}
            onChange={handleChange}
        />
    )
}
